<template>
  <section :class="{ 'animated-section': true, 'section-active': ready }" style="overflow: hidden">
    <div class="page-title">
      <h2>Resume</h2>
    </div>

    <div class="section-content">
      <div class="row">
        <div class="col-xs-12 col-sm-7">
          <div class="block-title">
            <h3>Experience</h3>
          </div>

          <div class="timeline timeline-second-style clearfix">
            <div
              class="timeline-item clearfix"
              v-for="(item, i) in data.resume.experience"
              :key="i"
            >
              <div class="left-part">
                <h5 class="item-period">{{ item.years }}</h5>
                <span class="item-company">{{ item.name }}</span>
              </div>
              <div class="divider"></div>
              <div class="right-part">
                <h4 class="item-title">{{ item.as }}</h4>
                <p>
                  {{ item.describtion }}
                </p>
              </div>
            </div>
          </div>

          <div class="white-space-50"></div>

          <div class="block-title">
            <h3>Education</h3>
          </div>

          <div class="timeline timeline-second-style clearfix">
            <div class="timeline-item clearfix" v-for="(item, i) in data.resume.education" :key="i">
              <div class="left-part">
                <h5 class="item-period">{{ item.years }}</h5>
                <span class="item-company">{{ item.name }}</span>
              </div>
              <div class="divider"></div>
              <div class="right-part">
                <p>
                  {{ item.describtion }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Skills & Certificates -->
        <div class="col-xs-12 col-sm-5">
          <!-- Design Skills -->
          <div class="block-title">
            <h3>Design <span>Skills</span></h3>
          </div>

          <div class="skills-info skills-second-style">
            <div v-for="(item, i) in data.resume.skills.design" :key="i">
              <div class="skill clearfix">
                <h4>{{ item.name }}</h4>
                <div class="skill-value">{{ item.percentage }}%</div>
              </div>
              <div :class="`skill-container skill-${item.percentage}`">
                <div class="skill-percentage"></div>
              </div>
            </div>
          </div>
          <!-- End of Design Skills -->

          <div class="white-space-10"></div>

          <!-- Frontend Skills -->
          <div class="block-title">
            <h3>Frontend <span>Skills</span></h3>
          </div>

          <div class="skills-info skills-second-style">
            <div v-for="(item, i) in data.resume.skills.frontend" :key="i">
              <div class="skill clearfix">
                <h4>{{ item.name }}</h4>
                <div class="skill-value">{{ item.percentage }}%</div>
              </div>
              <div :class="`skill-container skill-${item.percentage}`">
                <div class="skill-percentage"></div>
              </div>
            </div>
          </div>
          <!-- End of Frontend Skills -->

          <div class="white-space-10"></div>

          <!-- Backend Skills -->
          <div class="block-title">
            <h3>Backend <span>Skills</span></h3>
          </div>

          <div class="skills-info skills-second-style">
            <div v-for="(item, i) in data.resume.skills.backend" :key="i">
              <div class="skill clearfix">
                <h4>{{ item.name }}</h4>
                <div class="skill-value">{{ item.percentage }}%</div>
              </div>
              <div :class="`skill-container skill-${item.percentage}`">
                <div class="skill-percentage"></div>
              </div>
            </div>
          </div>
          <!-- End of Backend Skills -->

          <div class="white-space-10"></div>

          <!-- Mobile Hybrid Skills -->
          <div class="block-title">
            <h3>Mobile Hybrid <span>Skills</span></h3>
          </div>

          <div class="skills-info skills-second-style">
            <div v-for="(item, i) in data.resume.skills.mobile" :key="i">
              <div class="skill clearfix">
                <h4>{{ item.name }}</h4>
                <div class="skill-value">{{ item.percentage }}%</div>
              </div>
              <div :class="`skill-container skill-${item.percentage}`">
                <div class="skill-percentage"></div>
              </div>
            </div>
          </div>
          <!-- End of Mobile Hybrid Skills -->

          <div class="white-space-10"></div>

          <!-- Language Skills -->
          <div class="block-title">
            <h3>Language <span>Skills</span></h3>
          </div>

          <div class="skills-info skills-second-style">
            <div v-for="(item, i) in data.resume.skills.language" :key="i">
              <div class="skill clearfix">
                <h4>{{ item.name }}</h4>
                <div class="skill-value">{{ item.percentage }}%</div>
              </div>
              <div :class="`skill-container skill-${item.percentage}`">
                <div class="skill-percentage"></div>
              </div>
            </div>
          </div>
          <!-- End of Language Skills -->

          <div class="white-space-10"></div>

          <!-- Deployment Skills -->
          <div class="block-title">
            <h3>Deployment <span>Skills</span></h3>
          </div>

          <div class="skills-info skills-second-style">
            <div v-for="(item, i) in data.resume.skills.deployment" :key="i">
              <div class="skill clearfix">
                <h4>{{ item.name }}</h4>
                <div class="skill-value">{{ item.percentage }}%</div>
              </div>
              <div :class="`skill-container skill-${item.percentage}`">
                <div class="skill-percentage"></div>
              </div>
            </div>
          </div>
          <!-- End of Deployment Skills -->

          <div class="white-space-10"></div>

          <div class="white-space-10"></div>

          <!-- OS Skills -->
          <div class="block-title">
            <h3>OS <span>Skills</span></h3>
          </div>

          <div class="skills-info skills-second-style">
            <div v-for="(item, i) in data.resume.skills.os" :key="i">
              <div class="skill clearfix">
                <h4>{{ item.name }}</h4>
                <div class="skill-value">{{ item.percentage }}%</div>
              </div>
              <div :class="`skill-container skill-${item.percentage}`">
                <div class="skill-percentage"></div>
              </div>
            </div>
          </div>
          <!-- End of OS Skills -->

          <!-- Knowledges -->
          <div class="block-title">
            <h3>Knowledges</h3>
          </div>

          <ul class="knowledges">
            <li v-for="(item, i) in data.resume.knowledges" :key="i">{{ item }}</li>
          </ul>
          <!-- End of Knowledges -->
        </div>
        <!-- End of Skills & Certificates -->
      </div>

      <!-- <div class="white-space-50"></div>

      <div class="row">
        <div class="col-xs-12 col-sm-12">
          <div class="block-title">
            <h3>Certificates</h3>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <div class="certificate-item clearfix">
            <div class="certi-logo">
              <img src="img/clients/client-1.png" alt="logo" />
            </div>

            <div class="certi-content">
              <div class="certi-title">
                <h4>Psyhology of Intertnation Design</h4>
              </div>
              <div class="certi-id">
                <span>Membership ID: XXXX</span>
              </div>
              <div class="certi-date">
                <span>19 April 2018</span>
              </div>
              <div class="certi-company">
                <span></span>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </section>
</template>
<script>
import { onMounted, ref, onBeforeUnmount, inject } from 'vue'

export default {
  setup() {
    const data = inject('data')
    const scrollbar = inject('scrollbar')
    const ready = ref(false)

    onMounted(() => {
      ready.value = true
      setTimeout(() => {
        scrollbar.enabled = true
        scrollbar.init = true
      }, 500)
    })

    onBeforeUnmount(() => {
      ready.value = false
      scrollbar.enabled = false
    })

    return { data, ready }
  }
}
</script>
